import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"; // ✅ Import correcto

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
